module.exports = __webpack_public_path__ + "img/heart-on.be39ee7f.svg";